import { generateRoutes, ROUTE_MODE,  getMenuRoutes, getDynamicRoutesIncremental, mergeRoutes } from './index';
import { staticMenuRoutes } from './router/staticMenuRoutes';

// 路由管理器 统一管理路由配置的获取和缓存
class RouteManager {
    constructor() {
        this.routes = null;
        this.menuRoutes = null;
        this.loading = false;
        this.listeners = [];
        this.initCallbacks = []; // 初始化完成回调列表
        this.isInitialized = false; // 是否初始化完成

        // 初始化
        this.init();
    }

    // 执行初始化回调
    executeInitCallbacks() {
        this.initCallbacks.forEach(callback => {
            callback({
                routes: this.routes,
                menuRoutes: this.menuRoutes,
                loading: this.loading
            });
        });
        // 清空回调列表
        this.initCallbacks = [];
    }

    // 初始化路由
     init() {
        if (ROUTE_MODE === 'dynamic') {
            // 动态模式：等待 API 返回
            this.loading = true;
            this.routes = generateRoutes([], true); // 传递 isLoading = true
            this.notifyListeners();
             this.loadDynamicRoutes();
        } else if (ROUTE_MODE === 'mixed') {
            // 混合模式：等待动态路由获取完成后再生成完整路由
            this.loading = true;
            this.menuRoutes = [...staticMenuRoutes];
            // 先不生成路由，等待动态路由获取完成
            this.routes = generateRoutes([], true); // 传递 isLoading = true
            this.notifyListeners();

            // 异步获取动态路由并合并
             this.loadAndMergeDynamicRoutes();
            this.loading = false;
            this.routes = generateRoutes(this.menuRoutes, false);
            this.notifyListeners();
        } else {
            // 静态模式直接使用本地配置
            this.menuRoutes = [...staticMenuRoutes];
            this.routes = generateRoutes(this.menuRoutes);
            this.loading = false;
            this.notifyListeners();
        }
        
        // 标记初始化完成并执行回调
        this.isInitialized = true;
        this.executeInitCallbacks();
    }

    // 加载动态路由（用于 dynamic 模式）
     loadDynamicRoutes() {
        try {
            const menuRoutes =  getMenuRoutes();
            this.menuRoutes = menuRoutes;
            this.routes = generateRoutes(menuRoutes, false);
            this.loading = false;
            this.notifyListeners();
        } catch (error) {
            console.error('加载动态路由失败:', error);
            // 失败时使用静态配置
            this.menuRoutes = [...staticMenuRoutes];
            this.routes = generateRoutes(this.menuRoutes, false);
            this.loading = false;
            this.notifyListeners();
        }
    }

    // 加载并合并动态路由（用于 mixed 模式）
     loadAndMergeDynamicRoutes() {
        try {
            const dynamicRoutes =  getDynamicRoutesIncremental();

            if (dynamicRoutes && dynamicRoutes.length > 0) {
                // 合并静态路由和动态路由
                const mergedRoutes = mergeRoutes(this.menuRoutes, dynamicRoutes);
                this.menuRoutes = mergedRoutes;
            } else {
                console.warn('动态路由为空或未获取到数据');
            }
        } catch (error) {
            console.error('混合模式：获取动态路由失败', error);
        }
    }

    // 获取路由配置
    getRoutes() {
        return this.routes;
    }

    // 获取菜单路由配置
    getMenuRoutes() {
        return this.menuRoutes;
    }

    // 获取加载状态
    isLoading() {
        return this.loading;
    }

    // 订阅路由变化
    subscribe(listener) {
        this.listeners.push(listener);
        // 立即通知一次当前状态
        listener({
            routes: this.routes,
            menuRoutes: this.menuRoutes,
            loading: this.loading
        });
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    // 通知所有订阅者
    notifyListeners() {
        this.listeners.forEach(listener => listener({
            routes: this.routes,
            menuRoutes: this.menuRoutes,
            loading: this.loading
        }));
    }

    // 注册初始化完成回调
    onInit(callback) {
        if (this.isInitialized) {
            // 如果已经初始化完成，直接执行回调
            callback({
                routes: this.routes,
                menuRoutes: this.menuRoutes,
                loading: this.loading
            });
        } else {
            // 否则添加到回调列表
            this.initCallbacks.push(callback);
        }
    }
}

// 创建单例实例
const routeManager = new RouteManager();

export default routeManager;
